import React from "react";
import clsx from "clsx";

export const Tag = ({ className, children, ...props }: React.HTMLAttributes<HTMLDivElement>) => {
  return <div className={clsx("px-2 h-8 flex items-center justify-center border border-solid border-foreground text-sm", className)} {...props}>{children}</div>;
};
